import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Course from '../Course/Course';


const OurCourses = () => {
    const [courses, setCourses] = useState([]);
    /* get data from json */
    useEffect(() => {
        fetch('./courses.JSON')
            .then(res => res.json())
            .then(data => setCourses(data))

    }, [])
    return (
        /* Show data in UI */
        <div className="Container mx-5 p-5 " >
            <h2 className="mb-4">Our Courses</h2>
            <Row xs={1} md={3} className="g-4">

                {
                    courses.map(course => <Course
                        key={course.id}
                        course={course}
                    ></Course>)
                }

            </Row>
        </div>

    );
};

export default OurCourses;